import type { EnrichmentStatusEvent } from '../../../hooks/useEnrichmentStream';

type Translate = (key: string) => string;

const RAW_PROVIDER_ERROR = /apify run|ended with status/i;
const PROFILE_NOT_FOUND_CODE = 'ENRICHMENT_PROFILE_NOT_FOUND';

export function resolveEnrichmentFailureMessage(
  event: Pick<EnrichmentStatusEvent, 'status' | 'error' | 'errorCode'>,
  t: Translate,
): string {
  if (event.status === 'auth_failed') {
    return t('workflow.errors.authRequired');
  }

  if (event.errorCode === PROFILE_NOT_FOUND_CODE) {
    return t('workflow.errors.profileNotFound');
  }

  const fallback = t('workflow.errors.enrichmentUnavailable');
  const raw = event.error?.trim();

  if (!raw || RAW_PROVIDER_ERROR.test(raw)) {
    return fallback;
  }

  return raw;
}
